export default {
    namespaced: false,
    state: {
        isShowLeftNavigationDrawer: false,
    },
    getters: {
        isShowLeftNavigationDrawer(state) {
            return state.isShowLeftNavigationDrawer
        },
    },
    mutations: {
        setIsShowLeftNavigationDrawer(state, value) {
            state.isShowLeftNavigationDrawer = value
        },
    },
    actions: {
        showLeftNavigationDrawer({ commit }) {
            commit('setIsShowLeftNavigationDrawer', true)
        },
        closeLeftNavigationDrawer({ commit }) {
            commit('setIsShowLeftNavigationDrawer', false)
        },
    },
}
